import { Fragment } from 'react';
import CommentList from './List';
import { Button } from 'core/components/form-controls';
import { CommunityPlusIcon } from 'core/assets/icons';
// import { commentList } from './mockData';
import CommentBox from './CommentBox';
import CommentItemLoading from './Loading';
import { CommentProps } from '.';
import { useGetCommentList } from './../../hooks';
import { _t } from "core/language";
import { useSearchParams } from 'react-router-dom';

const CommentComponent = ({ className = '', id }: CommentProps) => {
  const { data, loading, loadMore, hasMore, reLoadList } = useGetCommentList(id)
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "trending";
  return (
    <div className={`space-y-1.5 -mx-4 ${className}`}>
      <CommentList comments={data} reload={reLoadList} />
      {loading ? (
        !data.length ? (
          <Fragment>
            <CommentItemLoading />
            <CommentItemLoading />
            <CommentItemLoading />
            <CommentItemLoading />
            <CommentItemLoading />
          </Fragment>
        ) : null
      ) : (
        !data.length ? (
          <div className="h-28 flex items-center justify-center text-center py-2.5 px-4 text-[14px] tracking-tighter">
            {_t("comunity.comment.nodata")}
          </div>
        ) : null
      )}

      {/*load more button*/}
      {(data.length && hasMore) ? <div className="px-4">
        <Button
          classBtn="w-full text-center font-medium"
          label={_t("comunity.comment.load_more")}
          iconRight={!loading ? CommunityPlusIcon : null}
          size="lg"
          onClickBtn={loadMore}
          // disabled={!loading}
          loading={loading}
        />
      </div> : null}
      {/*create form*/}
      <CommentBox id={id} tab={tab} />
    </div>
  );
}

export default CommentComponent;
